/**
 * 整数 数字输入 加减组件
 *
 * Author:   FJJ
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2022/03/29      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 *
 * @param onChange 值改变回调事件
 * @param styleName 带入样式
 * @param defaultValue 默认显示值
 * @param maxValue  最大值
 // tips 划过提示，默认没有，配置禁用时 如果有提示内容，点击操作按钮将显示 -> dop 无
 * */
import React from "react";
import {isEmpty,} from '@utils/utils';
import PropTypes from "prop-types";
import "./IntegerCtrlInput.less"
class IntegerCtrlInput extends React.Component {
    static propTypes = {
        onChange: PropTypes.any,
        styleName: PropTypes.string,
        defaultValue: PropTypes.number,
        maxValue:PropTypes.number,
        minNumber:PropTypes.number, // 可操作最小值
        maxNumber:PropTypes.number, // 可操作最大值
        disabled:PropTypes.bool,
    };
    static defaultProps = {
        styleName:"",
        quantity: 1, //数量, 加减操作的数量
        value: 0,
        disabled: false, //是否显示符号
        tips:"",
        callbackChange:true, // 回调其他行为成功才改变值，如购物车加购成功才改变值，可设置为false,
    }
    constructor(props) {
        super(props);
        this.state = {
            valueState: "",
            inputIng:false,
        };
    }
    checkInputValue(value) {
        const {minNumber,maxNumber} = this.props;
        if(!value&&minNumber)return minNumber;
        if(!isEmpty(minNumber)&&value<minNumber) return minNumber; //控制不可小于最小值
        if(!isEmpty(maxNumber)&&value>maxNumber) return maxNumber; //控制不可大于最大值
        return value;
    }
    /**
     * 点击改变值
     * */
    onClickChange(value){
        const newValue = this.checkInputValue(value);
        const { callbackChange } = this.props;
        if(callbackChange){
            this.props.onChange&&this.props.onChange(newValue,()=>this.callback());
        }else {
            this.props.onChange&&this.props.onChange(newValue);
            this.callback()
        }
    }
    callback(){
        this.setState({valueState: ""});
    }
    onBlur(event){
        const { target:{ value = 0} } = event
        let newValue = value.replace(/[^\d]/g,"");  //清除 除“数字” 字符;
        newValue = Number(newValue)
        newValue = this.checkInputValue(newValue);
        if(newValue==this.props.value){// 新赋值 与现值一致 忽略
            this.callback()
        }else {
            const { callbackChange } = this.props;
            if(callbackChange){
                this.props.onChange&&this.props.onChange(newValue,()=>this.callback());
            }else {
                this.props.onChange&&this.props.onChange(newValue);
                this.callback()
            }
        }
        this.setState({
            inputIng:false
        })
    }
    /**
     * 输入框改变值
     * */
    handleChange(event) {
        const { target:{ value = 0} } = event
        this.setState({
            valueState: value,
            inputIng: true
        });
    }
    render() {
        const { quantity, disabled,value,styleName,tips} = this.props;
        const {valueState,inputIng} = this.state;
        return (<div className={`integer-flex-between ${disabled?" input-disabled":""}${styleName?" "+styleName:""}`}>
           <span className={"btn-default ri-subtract-line"} onClick={!disabled?()=>this.onClickChange(value-quantity):""} />
                <input className={"input-default"} type="text" value={inputIng?valueState:(valueState||value)} onChange={(e)=>this.handleChange(e)} onBlur={(e)=>this.onBlur(e)} disabled={disabled} />
            <span className={"btn-default ri-add-line"} onClick={!disabled?()=>this.onClickChange(value+quantity):""} />
        </div>);
    }
}


export default IntegerCtrlInput;